/* DelaFuente — Birthstone Picker.
 * Renders large gem color dots that drive the NATIVE "Birthstone" variant option (keeps per-stone
 * pricing) and hides the native control. Metal keeps its own native swatch. Vanilla, no deps.
 */
(function () {
  var cfgEl = document.getElementById('dlf-bs-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var OPT = CFG.option || 'Birthstone';
  var GEMS = CFG.gems || [];
  var IMGBASE = CFG.imgBase || '';
  var RING = CFG.ringSize === true;      // show ring-size selector (line-item property, not a variant)
  var SIZES = CFG.sizes || [];
  var ES = String(CFG.lang || '').slice(0, 2).toLowerCase() === 'es';
  var L = ES ? {
    helpLater: 'Ayúdame después', selectSize: 'Elige tu talla', ringSize: 'Talla del anillo',
    sizingLater: 'Confirmar tras la entrega — kit de medición gratis incluido',
    sizingNote: 'Con tu anillo llega un kit de medición gratis — confirma tu talla cuando llegue. Compra hoy.'
  } : {
    helpLater: 'Help me later', selectSize: 'Select size', ringSize: 'Ring size',
    sizingLater: 'Confirm after delivery — free sizing kit included',
    sizingNote: 'A free sizing kit ships with your ring — confirm your size once it arrives. Check out today.'
  };
  var SIZING_LATER = L.sizingLater;
  var SIZING_NOTE = L.sizingNote;
  var rsHelpLater = false;
  function cap(t) { t = String(t || ''); return t.charAt(0).toUpperCase() + t.slice(1); }
  var NAMEFOR = {};
  GEMS.forEach(function (g) { NAMEFOR[g.name] = g; });

  // Button options render as <fieldset class="variant-option"> with a <legend> label and
  // <label class="variant-option__button-label"><input type="radio" name="<OptName>-<hash>"></label>.
  // The radio name is NOT "options[Birthstone]", so locate the fieldset by its legend text.
  // A single-value option or a big list may instead be a <select name="options[Birthstone]">.
  function selCtrl() { return document.querySelector('select[name="options[' + OPT + ']"]'); }
  function bsFieldset() {
    var fss = document.querySelectorAll('fieldset.variant-option, .variant-option');
    for (var i = 0; i < fss.length; i++) {
      var lg = fss[i].querySelector('legend, .variant-option__label, label');
      if (lg && lg.textContent.trim().toLowerCase().indexOf(OPT.toLowerCase()) === 0) return fss[i];
    }
    return null;
  }
  function radios() {
    var fs = bsFieldset();
    return fs ? fs.querySelectorAll('input[type="radio"]') : [];
  }
  function nativeWrapper() {
    var sel = selCtrl();
    if (sel) return sel.closest('.variant-option') || sel.parentElement;
    return bsFieldset();
  }
  function current() {
    var sel = selCtrl();
    if (sel) return sel.value;
    var rs = radios();
    for (var i = 0; i < rs.length; i++) { if (rs[i].checked) return rs[i].value; }
    return null;
  }
  function fireRadio(r) {
    r.checked = true;
    r.dispatchEvent(new Event('input', { bubbles: true }));
    r.dispatchEvent(new Event('change', { bubbles: true }));
    if (r.id) { var lbl = document.querySelector('label[for="' + r.id + '"]'); if (lbl) lbl.click(); }
    else { var p = r.closest('label'); if (p) p.click(); }
  }
  function selectStone(name) {
    var sel = selCtrl();
    if (sel) { sel.value = name; sel.dispatchEvent(new Event('change', { bubbles: true })); return; }
    var rs = radios();
    for (var i = 0; i < rs.length; i++) { if (rs[i].value === name) { if (!rs[i].checked) fireRadio(rs[i]); return; } }
  }

  var root;
  function build() {
    if (document.querySelector('.dlf-bs')) return true;
    var fs = bsFieldset();
    if (!fs) return false;

    root = document.createElement('div');
    root.className = 'dlf-bs';

    var label = document.createElement('div');
    label.className = 'dlf-bs__label';
    label.appendChild(document.createTextNode(OPT + ' '));      // OPT is the localized option name ("Birthstone" / "Piedra de nacimiento")
    var _selSpan = document.createElement('span');
    _selSpan.className = 'dlf-bs__sel';
    label.appendChild(_selSpan);

    var grid = document.createElement('div');
    grid.className = 'dlf-bs__grid';
    grid.setAttribute('role', 'group');
    grid.setAttribute('aria-label', OPT);

    GEMS.forEach(function (g) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'dlf-bs__item';
      b.setAttribute('data-name', g.name);
      b.setAttribute('aria-pressed', 'false');
      b.title = cap(g.month) + ' — ' + g.name;
      var inner = g.img
        ? '<img src="' + IMGBASE + g.img + '" alt="" loading="lazy">'
        : '';
      // 1-nov-2026 (Danna): debajo de cada piedra va el MES; el nombre de la piedra sale arriba, junto a la etiqueta
      b.innerHTML =
        '<span class="dlf-bs__dot" style="background:' + g.hex + '">' + inner + '</span>' +
        '<span class="dlf-bs__name">' + cap(g.month) + '</span>';
      b.addEventListener('click', function () { selectStone(g.name); sync(); });
      grid.appendChild(b);
    });

    root.appendChild(label);
    root.appendChild(grid);
    // Insert OUTSIDE variant-picker__form (before the ring-size guide / buy buttons) so it SURVIVES
    // the theme's variant re-render. If it lived inside the variant picker it'd be wiped on every
    // variant change (which forced a MutationObserver rebuild -> infinite loop -> frozen page).
    var a = document.querySelector('a[href*="ring-size-guide"]');
    var anchor = (a && (a.closest('[class*="text-block"]') || a.closest('p'))) ||
                 (mainBtn() && (mainBtn().closest('[class*="buy-buttons"]') || mainBtn().closest('form')));
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(root, anchor);
    else fs.parentNode.insertBefore(root, fs.nextSibling);
    return true;
  }

  function hideNative() {
    var fs = bsFieldset();
    if (fs && !fs.classList.contains('dlf-bs-native-hidden')) fs.classList.add('dlf-bs-native-hidden');
    return fs;
  }

  function sync() {
    var r = document.querySelector('.dlf-bs');
    if (!r) return;
    var cur = current();
    r.querySelectorAll('.dlf-bs__item').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-name') === cur));
    });
    var selSpan = r.querySelector('.dlf-bs__sel');
    if (selSpan) { var g = NAMEFOR[cur]; selSpan.textContent = g ? ('· ' + g.name) : ''; }
  }

  // ---- Ring size as a line-item property + "Help me later" ----
  // (12 stones × 3 metals × sizes would blow past Shopify's 100-variant cap, so size is a property.)
  function form() { return document.querySelector('form[action*="/cart/add"]'); }
  function mainBtn() { var f = form(); return f && f.querySelector('button[type="submit"]'); }
  function setProp(name, val) {
    var f = form(); if (!f) return;
    var el = f.querySelector('input[data-dlf-rs="' + name + '"]');
    if (val == null) { if (el) el.remove(); return; }
    if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.setAttribute('data-dlf-rs', name); el.name = 'properties[' + name + ']'; f.appendChild(el); }
    el.value = val;
  }
  function rsSelect() { return document.querySelector('.dlf-rs__select'); }
  function rsCurrent() { var s = rsSelect(); return s ? s.value : ''; }
  function rsGate() {
    var btn = mainBtn(); if (!btn) return;
    if (RING && !rsHelpLater && !rsCurrent()) { btn.setAttribute('data-rs-required', ''); btn.disabled = true; }
    else { btn.removeAttribute('data-rs-required'); if (!btn.hasAttribute('data-oos') && !btn.hasAttribute('data-nps-required')) btn.disabled = false; }
  }
  function rsSwapGuide() {
    var swapped = document.querySelector('.dlf-sizeguide-swapped');
    var a = document.querySelector('a[href*="ring-size-guide"]');
    var line = swapped || (a ? (a.closest('p') || a.parentElement) : null);
    if (!line) return;
    if (rsHelpLater) {
      if (!line.classList.contains('dlf-sizeguide-swapped')) { line.setAttribute('data-dlf-orig', line.innerHTML); line.classList.add('dlf-sizeguide-swapped'); }
      if (line.textContent.trim() !== SIZING_NOTE) line.textContent = SIZING_NOTE;
    } else if (line.classList.contains('dlf-sizeguide-swapped')) {
      var orig = line.getAttribute('data-dlf-orig'); if (orig != null) line.innerHTML = orig;
      line.classList.remove('dlf-sizeguide-swapped'); line.removeAttribute('data-dlf-orig');
    }
  }
  function rsHelpUI() {
    var rs = document.querySelector('.dlf-rs'); if (!rs) return;
    var btn = rs.querySelector('.dlf-rs__help');
    btn.textContent = (rsHelpLater ? '✓ ' : '') + L.helpLater;
    btn.classList.toggle('is-on', rsHelpLater);
    var w = rs.querySelector('.variant-option__select-wrapper');
    if (w) w.classList.toggle('dlf-size-dim-on', rsHelpLater);
    setProp('Sizing', rsHelpLater ? SIZING_LATER : null);
    rsSwapGuide();
  }
  function buildRS() {
    if (!RING) return false;
    if (document.querySelector('.dlf-rs')) return true;
    var a = document.querySelector('a[href*="ring-size-guide"]');
    var guide = a ? (a.closest('[class*="text-block"]') || a.closest('p')) : null;
    var anchor = guide || (mainBtn() && (mainBtn().closest('[class*="buy-buttons"]') || mainBtn().closest('form')));
    if (!anchor || !anchor.parentNode) return false;
    var opts = '<option value="">' + L.selectSize + '</option>';
    SIZES.forEach(function (s) { opts += '<option value="' + s + '">' + s + '</option>'; });
    var rs = document.createElement('div');
    rs.className = 'dlf-rs';
    rs.innerHTML =
      '<div class="dlf-rs__label">' + L.ringSize + '</div>' +
      '<div class="variant-option__select-wrapper dlf-hml-host">' +
        '<select class="variant-option__select dlf-rs__select" aria-label="' + L.ringSize + '">' + opts + '</select>' +
        '<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>' +
        '<button type="button" class="dlf-hml-btn dlf-rs__help">' + L.helpLater + '</button>' +
      '</div>';
    anchor.parentNode.insertBefore(rs, anchor);
    var sel = rs.querySelector('.dlf-rs__select');
    sel.addEventListener('change', function () {
      if (sel.value) { rsHelpLater = false; rsHelpUI(); setProp('Ring size', sel.value); }
      else { setProp('Ring size', null); }
      rsGate();
    });
    rs.querySelector('.dlf-rs__help').addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      rsHelpLater = !rsHelpLater;
      if (rsHelpLater) { sel.value = ''; setProp('Ring size', null); }
      rsHelpUI(); rsGate();
    });
    setProp('Ring size', null); setProp('Sizing', null);
    var btn = mainBtn();
    if (btn && !btn.__dlfRsObs) {
      var obs = new MutationObserver(function () {
        if (RING && !rsHelpLater && !rsCurrent() && !btn.disabled) { btn.disabled = true; btn.setAttribute('data-rs-required', ''); }
      });
      obs.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
      btn.__dlfRsObs = obs;
    }
    return true;
  }

  // Re-establish on every theme re-render of the variant options (variant change, editor block select),
  // which otherwise wipes our picker and un-hides the native buttons.
  var _busy = false;
  function ensure() {
    if (_busy) return false;
    var fs = bsFieldset();
    if (!fs) return false;
    _busy = true;
    hideNative();
    if (!document.querySelector('.dlf-bs')) build();
    sync();
    if (RING) { buildRS(); rsGate(); }
    _busy = false;
    return true;
  }

  // Re-establish on the theme's variant:update (fires once after the theme finishes re-rendering the
  // options). No MutationObserver — that caused a rebuild->mutation->rebuild infinite loop.
  document.addEventListener('variant:update', function () { ensure(); rsGate(); });

  // Try synchronously first (the script loads after the variant markup), so the native
  // fieldset is hidden and the gem dots exist before the first paint — no flash.
  var tries = 0;
  if (!ensure()) {
    var iv = setInterval(function () {
      if (ensure()) clearInterval(iv);
      else if (++tries > 25) clearInterval(iv);
    }, 250);
  }
})();
